import { render, staticRenderFns } from "./TaskConfigurationWizard.vue?vue&type=template&id=b1bf882a&"
import script from "./TaskConfigurationWizard.vue?vue&type=script&lang=ts&"
export * from "./TaskConfigurationWizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports